// ControlePeriodiqueForm.js
import React, { useState, useEffect, useRef } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { doc, getDoc, collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";

const getSections = (isRouge, hasCleverSafe) => {
  const tablierVert = [
    "Aspect général", "Section basse", "Sections intermédiaires", "Section haute", "Calage des roulettes",
    "Roulette FIT Max (Verte)", "Bras haut roulettes FIT X-Trem (Bleu) - si concerné", "Roulettes Fit X-Trem (bleu) - si concerné",
    "Ressort de calage pour roulette Fit X-trem (bleu) - si concerné", "Excentriques", "Serrage des vis des écrous",
    "Axes des charnières", "Joints latéraux", "Plaque de firme avec QR-Code instruction (face extérieure de la porte)",
    "Sticker sécurité section basse", "Plaque CE sur section haute côté intérieur", "Charnières", "Charnière support",
    "Fermeture", "Verrouillage", "Poignée de levage", "Dragonne", "Joint haut", "Joints latéraux finaux"
  ];

  const tablierRouge = [
    "Aspect général", "Section basse", "Sections intermédiaires", "Section haute", "Roulette",
    "Calage des roulettes", "Charnières centrales", "Charnières support roulette", "Profils charnières continues (si porte CC)",
    "Bras haut", "Attaches câble", "Fermeture", "Verrouillage", "Poignée de levage", "Dragonne",
    "Joint haut", "Joints latéraux", "Plaque CE sur section haute (si concerné)"
  ];

  const rails = [
    "Aspect général", "Jonction rails horizontaux/verticaux (continue)", "Fixation rails",
    "Parallélisme des rails entre côté chauffeur et passager", "Fixation double rails (VAT uniquement)"
  ];

  const ressorts = [
    "Aspect général", "État arbre", "Goupilles arbre ressort", "Serrage pièces d'immobilisation",
    "Serrage support central", "Position des câbles", "Tension"
  ];

  const cadreVert = [
    "Équerrage cadre arrière", "Parallélisme", "Parois latérales", "Bois", "Isolées",
    "Type de pavillon", "Translucide", "Isolé"
  ];

  const cadreRouge = [
    "Équerrage cadre arrière", "Parallélisme", "Parois latérales"
  ];

  const clever = [
    "État général", "Plaque CE intérieur coffret", "Fixation du vérin", "Test commande extérieure montée",
    "Test commande extérieure descente", "Test commande Safe On/Off", "Test montée par impulsion",
    "Test commande intérieure caisse montée", "Position du vérin par rapport au cadre", "Contrôle position alignement du vérin",
    "Serrage embase + axe", "Serrage chape + axe", "Serrage barre de liaison et contre écrou", "Racleur",
    "Bande extérieure (métallique)", "Bande intérieure (bleue)", "Navette sur vérin", "Capteur de fin de course porte ouverte",
    "Renfort sur section haute", "Coffret de commande", "Fusible de protection batterie", "Buzzer porte ouverte",
    "Capteur de fin de course", "Soupape de sécurité", "Verrouillage sécurité Safe", "Circuit d'air", "Faisceau d'alimentation"
  ];

  const verifs = [
    "Arrêt porte en position haute", "Position correcte des butées",
    "Étiquettes de sécurité présentes", "Fixation correcte des éléments"
  ];

  const mesures = [
    "Déclenchement de la sécurité safe", "Fluidité du cycle de montée",
    "Fluidité du cycle de descente", "Pression coffret de commande (Bars)",
    "Temps de cycle montée (Secondes)", "Temps de cycle descente (Secondes)",
    "Fuites (Vérin)", "Tension à la batterie"
  ];

  return {
    tablier: isRouge ? tablierRouge : tablierVert,
    rails,
    ressorts,
    cadre: isRouge ? cadreRouge : cadreVert,
    clever: hasCleverSafe ? clever : [],
    verifs: hasCleverSafe ? [] : verifs,
    mesures
  };
};

const ControlePeriodiqueForm = () => {
  const { productId } = useParams();
  const [searchParams] = useSearchParams();
  const isPreviewMode = searchParams.get('preview') === 'true';
  
  const [loading, setLoading] = useState(true);
  const [productType, setProductType] = useState("");
  const [hasCleverSafe, setHasCleverSafe] = useState(false);
  const [dossierId, setDossierId] = useState(null);
  const sigCanvasRef = useRef(null);

  const [formData, setFormData] = useState({
    prestataire: "", adresse: "", contactPrestataire: "", date: "",
    clientNom: "", clientAdresse: "", clientContact: "",
    vehiculeType: "", vehiculeImmat: "", vehiculeMarque: "", vehiculeIdentifiant: "", porteNumeroSerie: "",
    probleme: "", commentaireProbleme: "",
    controles: { tablier: {}, rails: {}, ressorts: {}, cadre: {}, clever: {}, verifs: {}, mesures: {} },
    signature: ""
  });

  useEffect(() => {
    const fetchProduct = async () => {
      const ref = doc(db, "products-controle-periodique", productId);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setProductType(data.name || "");
        setHasCleverSafe((data.categorie || "").toUpperCase() === "SAFE");
      }
    };

    const findDossierId = async () => {
      const snapshot = await getDocs(collection(db, "dossiers"));
      for (const docSnap of snapshot.docs) {
        const data = docSnap.data();
        const found = (data.produits || []).find(
          (p) =>
            p.uuid === productId ||
            p.productId === productId ||
            encodeURIComponent((p.name || "").toLowerCase()) === productId
        );
        if (found) {
          setDossierId(docSnap.id);
          return;
        }
      }
    };

    fetchProduct();
    findDossierId();
    setLoading(false);
  }, [productId]);

  const isRouge = !productType.toUpperCase().includes("HUSKY");
  const sections = getSections(isRouge, hasCleverSafe);

  const handleInputChange = (section, key, value) => {
    if (isPreviewMode) return; // Bloquer les modifications en mode preview
    
    setFormData((prev) => ({
      ...prev,
      controles: {
        ...prev.controles,
        [section]: {
          ...prev.controles[section],
          [key]: value,
        },
      },
    }));
  };

  const handleGeneratePDF = async () => {
    if (isPreviewMode) return; // Bloquer la génération en mode preview
    if (!dossierId) return alert("Aucun dossier CE trouvé.");
    const signatureData = sigCanvasRef.current?.toDataURL() || "";

    const baseUrl = process.env.NODE_ENV === "production"
      ? "https://veryfit.onrender.com"
      : "http://localhost:5000";

    try {
      const response = await axios.post(
        `${baseUrl}/api/dossiers/controle-periodique/generate/${dossierId}/${productId}`,
        { ...formData, signature: signatureData }
      );
      if (response.data?.url) {
        window.open(response.data.url, "_blank");
      } else {
        alert("PDF généré mais aucune URL reçue.");
      }
    } catch (err) {
      console.error(err);
      alert("Erreur lors de la génération du PDF.");
    }
  };

  const renderSection = (sectionName, questions) => (
    <div className={`border p-4 mb-4 rounded-lg ${isPreviewMode ? 'bg-gray-50 border-gray-300' : 'bg-white border-gray-200'}`}>
      <h2 className={`font-bold text-lg mb-2 ${isPreviewMode ? 'text-gray-700' : 'text-gray-900'}`}>
        {sectionName}
        {isPreviewMode && (
          <span className="ml-2 text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full font-normal">
            Aperçu
          </span>
        )}
      </h2>
      {questions.map((q, index) => (
        <div key={index} className="flex items-center gap-4 mb-2">
          <label className={`w-1/2 ${isPreviewMode ? 'text-gray-600' : 'text-gray-900'}`}>{q}</label>
          {q.toLowerCase().includes("pression") || q.toLowerCase().includes("temps") || q.toLowerCase().includes("tension") ? (
            <input
              type="text"
              disabled={isPreviewMode}
              className={`border p-2 rounded w-1/2 ${
                isPreviewMode 
                  ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed' 
                  : 'bg-white border-gray-200'
              }`}
              placeholder={isPreviewMode ? "Valeur à saisir" : ""}
              onChange={(e) => handleInputChange(sectionName.toLowerCase(), q, e.target.value)}
            />
          ) : (
            <div className="flex gap-2">
              {["O", "So", "N"].map((val) => (
                <label key={val} className={`flex items-center ${isPreviewMode ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                  <input
                    type="radio"
                    name={`${sectionName}-${index}`}
                    value={val}
                    disabled={isPreviewMode}
                    className={isPreviewMode ? 'cursor-not-allowed opacity-50' : ''}
                    onChange={() => handleInputChange(sectionName.toLowerCase(), q, val)}
                  />
                  <span className={`ml-1 ${isPreviewMode ? 'text-gray-500' : 'text-gray-900'}`}>{val}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!productType) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 text-lg mb-4">❌ Produit introuvable</p>
          <Link
            to="/revendeur/dashboard"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            Retour au dashboard
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header avec indicateur de mode */}
      <div className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-4">
              <Link
                to="/revendeur/dashboard"
                className="text-gray-600 hover:text-gray-800 transition-colors"
              >
                ← Retour
              </Link>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  {isPreviewMode ? 'Aperçu' : 'Contrôle Périodique'} – {productType}
                </h1>
                {isPreviewMode && (
                  <div className="flex items-center mt-1">
                    <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      Mode aperçu - Lecture seule
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {isPreviewMode && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-2">
                <p className="text-yellow-800 text-sm font-medium">
                  🕒 Contrôle disponible après la période de 6 mois
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm border p-6">
          
          {/* Légende */}
          <div className={`mb-6 p-4 rounded-lg ${isPreviewMode ? 'bg-blue-50 border border-blue-200' : 'bg-gray-50'}`}>
            <p className={`italic ${isPreviewMode ? 'text-blue-700' : 'text-gray-600'}`}>
              <strong>Légende :</strong> 
              <strong className="ml-2">O</strong> = OK &nbsp;&nbsp;
              <strong>So</strong> = Sans objet &nbsp;&nbsp;
              <strong>N</strong> = Non conforme
              {isPreviewMode && (
                <span className="block mt-2 text-sm font-medium text-blue-800">
                  ℹ️ Ceci est un aperçu du formulaire. Les champs seront modifiables après la période d'attente.
                </span>
              )}
            </p>
          </div>

          <form onSubmit={(e) => e.preventDefault()}>
            {/* Informations générales */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Informations générales</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { field: "prestataire", label: "Prestataire" },
                  { field: "adresse", label: "Adresse" },
                  { field: "contactPrestataire", label: "Contact prestataire" },
                  { field: "date", label: "Date", type: "date" },
                  { field: "clientNom", label: "Nom client" },
                  { field: "clientAdresse", label: "Adresse client" },
                  { field: "clientContact", label: "Contact client" },
                  { field: "vehiculeType", label: "Type véhicule" },
                  { field: "vehiculeImmat", label: "Immatriculation" },
                  { field: "vehiculeMarque", label: "Marque véhicule" },
                  { field: "vehiculeIdentifiant", label: "Identifiant véhicule" },
                  { field: "porteNumeroSerie", label: "N° série porte" }
                ].map(({ field, label, type = "text" }) => (
                  <div key={field}>
                    <label className={`block text-sm font-medium mb-1 ${isPreviewMode ? 'text-gray-600' : 'text-gray-700'}`}>
                      {label}
                    </label>
                    <input
                      type={type}
                      disabled={isPreviewMode}
                      placeholder={isPreviewMode ? "À remplir lors du contrôle" : `Saisir ${label.toLowerCase()}`}
                      value={formData[field]}
                      onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                      className={`w-full border p-3 rounded-lg ${
                        isPreviewMode 
                          ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed' 
                          : 'bg-white border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                      }`}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Sections de contrôle */}
            <div className="space-y-6">
              {renderSection("1/ Contrôles tablier", sections.tablier)}
              {renderSection("2/ Contrôles rails", sections.rails)}
              {renderSection("3/ Ressorts (sauf VAT)", sections.ressorts)}
              {renderSection("4/ Caisse / cadre arrière", sections.cadre)}
              {hasCleverSafe
                ? renderSection("5/ Système Clever SAFE", sections.clever)
                : renderSection("6/ Vérifications complémentaires", sections.verifs)}
              {renderSection("7/ Relevés, mesures et contrôles", sections.mesures)}
            </div>

            {/* Section problèmes */}
            <div className={`mb-6 mt-8 p-4 rounded-lg ${isPreviewMode ? 'bg-gray-50 border border-gray-300' : 'bg-white border border-gray-200'}`}>
              <label className={`font-semibold block mb-2 ${isPreviewMode ? 'text-gray-700' : 'text-gray-900'}`}>
                Y a-t-il un problème ?
              </label>
              <select
                disabled={isPreviewMode}
                className={`border p-2 rounded w-full ${
                  isPreviewMode 
                    ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed' 
                    : 'bg-white border-gray-200'
                }`}
                value={formData.probleme}
                onChange={(e) => setFormData({ ...formData, probleme: e.target.value })}
              >
                <option value="">-- Sélectionner --</option>
                <option value="mineur">Problème mineur</option>
                <option value="majeur">Problème majeur</option>
              </select>
              {formData.probleme && (
                <textarea
                  disabled={isPreviewMode}
                  className={`border p-2 rounded w-full mt-2 ${
                    isPreviewMode 
                      ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed' 
                      : 'bg-white border-gray-200'
                  }`}
                  placeholder={isPreviewMode ? "Commentaire à saisir" : "Précisez la nature du problème..."}
                  value={formData.commentaireProbleme}
                  onChange={(e) => setFormData({ ...formData, commentaireProbleme: e.target.value })}
                />
              )}
            </div>

            {/* Section signature */}
            <div className={`mb-6 mt-8 p-4 rounded-lg ${isPreviewMode ? 'bg-gray-50 border border-gray-300' : 'bg-white border border-gray-200'}`}>
              <label className={`font-semibold block mb-2 ${isPreviewMode ? 'text-gray-700' : 'text-gray-900'}`}>
                Signature du vérificateur :
              </label>
              {isPreviewMode ? (
                <div className="border-2 border-dashed border-gray-300 rounded bg-gray-100 p-8 text-center">
                  <svg className="w-12 h-12 text-gray-400 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                  <p className="text-gray-500 text-sm">Zone de signature (disponible lors du contrôle)</p>
                </div>
              ) : (
                <>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{ width: 400, height: 150, className: "border rounded shadow bg-white" }}
                  />
                  <button
                    type="button"
                    className="text-sm text-blue-600 underline mt-2 hover:text-blue-700"
                    onClick={() => sigCanvasRef.current?.clear()}
                  >
                    Effacer la signature
                  </button>
                </>
              )}
            </div>

            {/* Boutons d'action */}
            <div className="flex gap-4 pt-6 border-t">
              <Link
                to="/revendeur/dashboard"
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Retour au dashboard
              </Link>
              
              {!isPreviewMode ? (
                <button
                  type="button"
                  onClick={handleGeneratePDF}
                  className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Générer PDF Contrôle Périodique
                </button>
              ) : (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-3">
                  <p className="text-yellow-800 text-sm">
                    📋 Le formulaire sera entièrement fonctionnel après la période d'attente de 6 mois
                  </p>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ControlePeriodiqueForm;